import { LogOutIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useLogout } from "@/hooks/useAuth";
import { authStore } from "@/store/useAuthStore";

/**
 * 헤더 오른쪽 끝의 로그인 사용자 — 아이디와 로그아웃 버튼.
 *
 * 로그아웃은 `useLogout` 이 한다: 로컬 세션을 먼저 지우고 `/login` 으로 보낸 뒤 서버
 * 세션(refresh 토큰)을 폐기한다. 사이드바의 옛 `NavUser` 처럼 `clearAuth` 만 부르면
 * 서버에는 세션이 그대로 남는다. 로그인 사용자가 없으면 아무것도 그리지 않는다.
 *
 * 아이디와 "로그아웃" 글자는 `xl`(1280px) 이상에서만 보이고 그보다 좁으면 아이콘만
 * 남는다 — 메뉴 다섯 묶음이 스크롤 없이 들어가는 폭을 글자가 더 잠식하지 않게
 * 하려는 것이다(아이콘만 있어도 그 폭은 ≈920px 에서 ≈990px 로 늘어난다). 글자가 `display: none` 이 되면 버튼의 접근 가능한 이름도 사라지므로
 * `aria-label` 을 둔다.
 */
export default function HeaderUser() {
  const userid = authStore((state) => state.user?.userid);
  const logout = useLogout();

  if (!userid) return null;

  return (
    <div className="flex shrink-0 items-center gap-2">
      <span
        title={userid}
        className="hidden max-w-32 truncate text-sm text-muted-foreground xl:inline"
      >
        {userid}
      </span>
      <Button
        variant="ghost"
        size="sm"
        aria-label="로그아웃"
        disabled={logout.isPending}
        onClick={() => logout.mutate()}
      >
        <LogOutIcon />
        <span className="hidden xl:inline">로그아웃</span>
      </Button>
    </div>
  );
}
